<div id="consumablesSummary" class="consumables-summary">
 @if(!isPreview) {
    <h2 class="pro-acc-title" [class.collapsed]="isCollapsed" id="proConsumablesSummary"
          (click)="isCollapsed = !isCollapsed"
          [attr.aria-expanded]="!isCollapsed" aria-controls="consumablesSummaryOne">
      Consumables Summary
      <!-- Shown on BOTH quotes and orders. On a quote it lets the rep show the customer the
           projected consumables required BEFORE the order is created. (The button was
           previously hidden on quotes via a `&& !isQuote` guard, now removed.) The popup
           fetches the projection itself, which the backend computes for any quote/order id. -->
      @if(!isOrderCancel && !consumableSummaryQuoteOrder?.is_consumable_calculator_applied) {
          <button type="button" class="pro-acc-btn" (click)="$event.stopImmediatePropagation();openConsumableCalculationPopUp(consumableSummaryQuoteOrder.id)">View Calculation</button>
      }
      <span class="pro-acc-icon"></span>
    </h2>
  }
   <div id="consumablesSummaryOne" class="pro-acc-body collapse" [class.show]="!isCollapsed" aria-labelledby="proConsumablesSummary" data-parent="#consumablesSummary">
    <table>
      <thead>
      <tr>
        <th>Product</th>
        <th>Total Product</th>
        <th>Units <small>(20 KG Bags)</small></th>
        <th>Units <small>(500 ML)</small></th>
        <th>Units <small>(2.5 L)</small></th>
        <th>Units <small>(5 L)</small></th>
        <th>Units <small>(15 L)</small></th>
        <th>Price <small>(Ex. GST)</small></th>
      </tr>
      </thead>

      <tbody>
      <tr>
        <td>Actichem CSD 50 Defender</td>
        <td>
          {{ summaryData?.totalDefender ? summaryData?.totalDefender : (0 | number : "1.0-2") }}
          <span>L</span>
        </td>
        <td>
          {{ summaryData?.defender?.twenty_kg_total_unit ? summaryData?.defender.twenty_kg_total_unit : 0 }}
        </td>
        <td>
          {{ summaryData?.defender?.five_hundred_total_unit ? summaryData?.defender.five_hundred_total_unit : 0 }}
        </td>
        <td>
          {{ summaryData?.defender?.two_thousand_five_hundred_total_unit ? summaryData?.defender.two_thousand_five_hundred_total_unit : 0 }}
        </td>
        <td>
          {{ summaryData?.defender?.five_thousand_total_unit ? summaryData?.defender.five_thousand_total_unit : 0 }}
        </td>
        <td>
          {{ summaryData?.defender?.fifteen_thousand_total_unit ? summaryData?.defender.fifteen_thousand_total_unit : 0 }}
        </td>
        <td>
          {{(summaryData?.totalDefenderPrice ? summaryData?.totalDefenderPrice : 0) | currency : "USD" : "symbol"}}
        </td>
      </tr>

      <tr>
        <td>Actichem Solv Sealer Gold</td>
        <td>
          {{summaryData?.totalGold ? summaryData?.totalGold : (0 | number : "1.0-2")}}
          <span>L</span>
        </td>

        <td>
          {{summaryData?.gold?.twenty_kg_total_unit ? summaryData?.gold.twenty_kg_total_unit : 0}}
        </td>

        <td>
          {{summaryData?.gold?.five_hundred_total_unit ? summaryData?.gold.five_hundred_total_unit : 0}}
        </td>
        <td>
          {{summaryData?.gold?.two_thousand_five_hundred_total_unit ? summaryData?.gold.two_thousand_five_hundred_total_unit : 0}}
        </td>
        <td>
          {{summaryData?.gold?.five_thousand_total_unit ? summaryData?.gold.five_thousand_total_unit : 0}}
        </td>
        <td>
          {{summaryData?.gold?.fifteen_thousand_total_unit ? summaryData?.gold.fifteen_thousand_total_unit : 0}}
        </td>
        <td>
          {{(summaryData?.totalGoldPrice ? summaryData?.totalGoldPrice : 0) | currency : "USD" : "symbol"}}
        </td>
      </tr>

      <tr>
        <td>Laticrete 335 Adhesive</td>
        <td>
          {{summaryData?.totalAdhesive ? summaryData?.totalAdhesive : 0}}
          <span>KG</span>
        </td>
        <td>
          {{summaryData?.laticrete_adhesive?.twenty_kg_total_unit ? summaryData?.laticrete_adhesive.twenty_kg_total_unit : 0}}
        </td>
        <td>
          {{summaryData?.laticrete_adhesive?.five_hundred_total_unit ? summaryData?.laticrete_adhesive.five_hundred_total_unit : 0}}
        </td>
        <td>
          {{summaryData?.laticrete_adhesive?.two_thousand_five_hundred_total_unit ? summaryData?.laticrete_adhesive.two_thousand_five_hundred_total_unit : 0}}
        </td>
        <td>
          {{summaryData?.laticrete_adhesive?.five_thousand_total_unit ? summaryData?.laticrete_adhesive.five_thousand_total_unit : 0}}
        </td>
        <td>
          {{summaryData?.laticrete_adhesive?.fifteen_thousand_total_unit ? summaryData?.laticrete_adhesive.fifteen_thousand_total_unit : 0}}
        </td>
        <td>
          {{(summaryData?.totalAdhesivePrice ? summaryData?.totalAdhesivePrice : 0) | currency : "USD" : "symbol"}}
        </td>
      </tr>
      <tr class="summary-total">
        <td colspan="6"></td>
        <td>Total Price (Ex. GST)</td>
        <td>{{
          summaryData
            ?.totalDefenderPrice +
          summaryData
            ?.totalGoldPrice +
          summaryData
            ?.totalAdhesivePrice
            | currency : "USD" : "symbol"
        }}</td>
      </tr>

      <!-- <tr>
        <td colspan="8">
          <div class="data-not-found">Consumables Summary not Found</div>
        </td>
      </tr> -->
      </tbody>
    </table>
  </div>
</div>